"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./FeatureList.css");
var FeatureLabel_1 = require("./components/FeatureLabel/FeatureLabel");
var utils_1 = require("../../../utils/utils");
var FeatureList = /** @class */ (function (_super) {
    __extends(FeatureList, _super);
    function FeatureList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { "data-test-id": this.props.testId }, this.props.data.features.map(function (feature, index) { return (React.createElement(FeatureLabel_1.default, { testId: utils_1.default(_this.props.testId, 'FeatureLabel'), data: feature, key: feature.text + '_' + index })); })));
    };
    return FeatureList;
}(React.Component));
exports.default = FeatureList;
//# sourceMappingURL=FeatureList.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/FeatureList/FeatureList.js
// module id = 1332
// module chunks = 8